<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
    <kendo-grid [kendoGridBinding]="organizationListAgainstProject" [reorderable]="true" [sortable]="true" [resizable]="true" [scrollable]="true" (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)" [filterable]="enableFilter" [pageSize]="15" [pageable]="true" (add)="addHandler()" [height]="600">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex">
                <div class="flex-grow-1 mat-panel-headerbar"></div>
                <div class="pagination-container">
                    <p id="lblShowDetails">Show</p>
                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                    </kendo-pager-page-sizes>
                    <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                </div>
                <div class="icons-container">
                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                        <div class="icon-wrap" (click)="toggleFilter()">
                            <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                            <span class="list-icon-name">Filter</span>
                        </div>
                        <div class="icon-wrap" (click)="toggleFullscreen()">
                            <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                            <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                        </div>
                    </div>
                    <div class="divider-container"><span></span></div>
                    <button kendoGridAddCommand>
                        <i class="fa fa-plus-circle" matTooltip="Add" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex+1}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Group Code" field="group_Code" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.group_Code}}" eipTooltipPosition="auto">{{dataItem.group_Code}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Group Short Name" field="group_Short_Name" [width]="170">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.group_Short_Name}}" eipTooltipPosition="auto">{{dataItem.group_Short_Name}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Group Name" field="group_Name" [width]="170">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <!-- create mode  -->
                <EIPAutoComplete ShowTextValueField='N' TextField="group_Name" floatLabelOption="never"  ValueField="group_Id" *ngIf="isNewRow" WaterMarkText="Group Name" [dataSource]='organizationListFiltered' setId="bglDD" (valueChange)='changeGroupName($event)'>
                </EIPAutoComplete>
                <!-- edit mode -->
                <span *ngIf="!isNewRow" class="no-wrap" eipTooltip="{{dataItem.group_Name}}" eipTooltipPosition="auto">{{dataItem.group_Name}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Created By" field="created_By" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">{{dataItem.created_By}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Created On" field="created_On" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.created_On | date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Modified By" field="modified_By" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto">{{dataItem.modified_By}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Modified On" field="modified_On" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.modified_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.modified_On | date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Is Active" field="is_Active" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.is_Active" [disabled]="true"></kendo-switch>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <mat-slide-toggle [checked]="dataItem.is_Active" color="primary" (change)="changeActiveStatus($event)"></mat-slide-toggle>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Actions" [width]="60">
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex" let-dataItem="dataItem">
                <div>
                    <button kendoGridEditCommand class="k-grid-add-command">
                        <i class="fa fa-pencil icon-size mr-2 eip-link" matTooltip="Edit" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                    </button>
                    <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                        <i class="fa fa-save icon-size mr-2 eip-link" matTooltip="Save" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                    </button>
                    <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                        <i class="fa fa-times-circle icon-size mr-2 eip-link" matTooltip="Cancel" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                    </button>
                </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>